<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M5.63672 5.63574L18.3646 18.3637" stroke="#223F53" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M5.63672 18.3643L18.3646 5.63634" stroke="#223F53" stroke-width="1.5" stroke-linecap="round"/>
</svg>
</template>